export const DAY_FORMAT = "dd MMM yyyy"

export const DATE_TIME_FORMAT = "dd MMM yyyy, hh:mm a"

/**
 * KA-1974 — numeric day-first format required by the accounting import. The Purchase Bill Template
 * reference sheet from KA-1385 uses `DD/MM/YYYY` (its example row reads `01/02/2022`), so the
 * export writes dates that way rather than in the `dd MMM yyyy` used for on-screen reading.
 */
export const DAY_FORMAT_NUMERIC = "dd/MM/yyyy"
